import { fetchWrapper } from '../../utils';

export class schoolAdmin {
  static baseUrl = process.env.REACT_APP_BASE_API + 'school/admin';

  /* LAPSOS Y SECCIONES */
  static async getLapsesAndSections(filters) {
    const url = `${this.baseUrl}/grades-and-sections`;
    return await fetchWrapper.post(url, filters);
  }

  static async getSections(filters) {
    const url = `${this.baseUrl}/sections`;
    return await fetchWrapper.post(url, filters);
  }

  static async getSchoolarsYears() {
    const url = `${this.baseUrl}/schoolyears`;
    return await fetchWrapper.post(url, {})
  }

  static async getGrades(filters) {
    const url = `${this.baseUrl}/grades`;
    return await fetchWrapper.post(url, filters);
  }

  static async createLapse(form) {
    const url = `${this.baseUrl}/createlapse`;
    return await fetchWrapper.post(url, form);
  }

  static async updateLapse(form) {
    const url = `${this.baseUrl}/updatelapse`;
    return await fetchWrapper.post(url, form);
  }

  static async deleteGroup(form) {
    const url = `${this.baseUrl}/deleteGroup`;
    return await fetchWrapper.post(url, form);
  }

  static async deleteLapse(form) {
    const url = `${this.baseUrl}/deleteLapse`;
    return await fetchWrapper.post(url, form);
  }

  static async createSections(form) {
    const url = `${this.baseUrl}/createsection`;
    return await fetchWrapper.post(url, form);
  }

  static async updateSections(form) {
    const url = `${this.baseUrl}/update-grades-sections`;
    return await fetchWrapper.post(url, form);
  }

  static async deleteGrade(form) {
    const url = `${this.baseUrl}/deletegrade`;
    return await fetchWrapper.post(url, form);
  }

  /* MATERIAS */
  static async getSubjects(filters) {
    const url = `${this.baseUrl}/subjects`;
    return await fetchWrapper.post(url, filters);
  }

  static async createSubject(form) {
    const url = `${this.baseUrl}/createSubjects`;
    return await fetchWrapper.post(url, form);
  }

  static async updateSubject(form) {
    const url = `${this.baseUrl}/updateSubject`;
    return await fetchWrapper.post(url, form);
  }

  static async deleteSubject(id) {
    const url = `${this.baseUrl}/deleteSubject`;
    return await fetchWrapper.post(url, id);
  }

  static async deleteSubjectByGrade(id) {
    const url = `${this.baseUrl}/deleteSubjectsByGrade`;
    return await fetchWrapper.post(url, id);
  }


  /* Horarios */
  static async getSchedulers(form) {
    const url = `${this.baseUrl}/schedulers`;
    return await fetchWrapper.post(url, form);
  }

  static async createSchedule(form) {
    const url = `${this.baseUrl}/schedulers/create`;
    return await fetchWrapper.post(url, form);
  }


  static async updateSchedule(form) {
    const url = `${this.baseUrl}/schedulers/update`;
    return await fetchWrapper.post(url, form);
  }
}



export class schoolAssignments {
  static baseUrl = process.env.REACT_APP_BASE_API + 'school/admin';

  static getSectionsAssignment = async (params) => {
    const url = `${this.baseUrl}/getSectionsAssignment`;
    return await fetchWrapper.post(url, params);
  }

  static getSections = async (params) => {
    const url = `${this.baseUrl}/sections`;
    return await fetchWrapper.post(url, params);
  }

  static assignSections = async (params) => {
    const url = `${this.baseUrl}/assignSections`;
    return await fetchWrapper.post(url, params);
  }
}

export class SchoolReports {
  static baseUrl = process.env.REACT_APP_BASE_API + 'school/reports';

  static getReports = async (params) => {
    return await fetchWrapper.post(this.baseUrl, params);
  }

  static getStudentsScore = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/studentTests', params);
  }

  static getStudentsGrades = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/studentGrades', params);
  }

  static getStudentsSections = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/studentSections', params);
  }

  static getSectionQualifications = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/sectionQualifications', params);
  }

  static downloadStudentCertificate = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/downloadStudentCertificate', params);
  }

  static downloadStudentQualificationsCertified = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/qualifications/certified', params);
  }

  static setStudentStatus = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/studentStatus', params);
  }

  static setPromotion = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/studentPromotion', params);
  }

  static downloadEnrolledStudents = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/students/download-enrolled-students', params);
  }

  static buildQualificationsExcel = async (params) => {
    return await fetchWrapper.post(this.baseUrl + '/qualifications/xlsx', params);
  }

}